<div class="fullcontainer">
    <div class="sheet">
      <h1 class='header'>Uninvoice NO: {{ this.invoice.id }}</h1>
  
      <p>Are you sure you wish to uninvoice all jobs under this invoice? 
          This action cannot be undone. When the invoice is deleted it will be gone forever.</p>
  
        
      <button type="submit" class="btn btn-danger" (click)='this.onCancelClicked()'>Yes! I'm Sure!</button>&nbsp;
      <button type="button" class="btn btn-primary" routerLink='/invoices'>No! Take me back!</button>
    </div>
  </div>
  